import { TYPE_SIZES } from '../../utils/globalConst.js';

//
var script = {
  name: 'Loader',
  props: {
    size: {
      type: String,
      default: 'normal'
    },
    isWhite: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    rootClass: function rootClass() {
      var obj;

      return ( obj = {}, obj[TYPE_SIZES.small.className] = this.size === TYPE_SIZES.small.value, obj[TYPE_SIZES.large.className] = this.size === TYPE_SIZES.large.value, obj['_white'] = this.isWhite, obj );
    }

  }
};

export default script;
